<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Reward Name </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="giftName" name="search" clearable @clear="search"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Pickup Redemption Centre </label>
                    <div class="col-sm-4">
                        <div>
                            <el-select clearable v-model="searchGiftStoreName" name="status">
                                <el-option v-for="item in giftStoreMap" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Redemption Member No </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="memberNo" name="search" clearable @clear="search"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Request Date</label>
                    <div class="col-sm-4">
                        <div>
                            <el-date-picker v-model="selectDate" type="daterange" start-placeholder="Start date"
                                end-placeholder="End date">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Status</label>
                    <div class="col-sm-4">
                        <div>
                            <el-select clearable v-model="selectStatus" name="status">
                                <el-option v-for="item in statusSelectMap" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Order No </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="orderNo" name="search" clearable @clear="search"></el-input>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-12 textRight">
                        <div class>
                            <el-button type="primary" @click="search">{{
                                $t("message.Search")
                            }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom: 60px">
                            <div class="col-sm-12">
                                <div class="pull-right">
                                    <el-button type="primary" @click="handleArrangeDelivery">Arrange Delivery</el-button>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                {{ total }}{{ $t("message.datagridresult") }}
                            </div>
                            <el-table @selection-change="handleSelectionChange" :data="rows" border style="width: 100%"
                                ref="multipleTable" row-key="id">
                                <el-table-column :selectable="item=>{return item.isHq != 1}" type="selection" width="55"></el-table-column>
                                <el-table-column prop="giftName" label="Reward Name" width="170">
                                </el-table-column>
                                <el-table-column prop="memberNo" label="Redemption Member No">
                                </el-table-column>
                                <el-table-column prop="qty" label="Quantity" width="90">
                                </el-table-column>
                                <el-table-column prop="totalStamp" label="Total J Coins" width="90">
                                </el-table-column>
                                <el-table-column prop="giftStoreName" label="Pickup Store Name">
                                </el-table-column>
                                <el-table-column prop="orderNo" label="Order No">
                                </el-table-column>
                                <el-table-column prop="createdAt" label="Request Timestamp">
                                </el-table-column>
                                <el-table-column prop="status" label="Status" width="120">
                                    <template slot-scope="scope">
                                        <div style="display: flex;justify-content: center;">{{
                                            statusMap[scope.row.status] }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="" width="270">
                                    <template slot-scope="scope
                                    ">
                                        <el-row v-if="scope.row.status == 0">
                                            <el-col :span="8">
                                                <el-popconfirm title="Are you sure you want to modify the status?"
                                                    confirmButtonText="Yes" cancelButtonText="No"
                                                    @confirm="updateStatusEvent(1, scope.row.id)">
                                                    <el-button v-if="scope.row.isHq == 1" size="mini" type="primary" style="width: 72px;"
                                                        slot="reference">Ready
                                                    </el-button>
                                                </el-popconfirm>
                                            </el-col>

                                            <el-col :span="8">
                                                <el-popconfirm title="Are you sure you want to modify the status?"
                                                    confirmButtonText="Yes" cancelButtonText="No"
                                                    @confirm="updateStatusEvent(2, scope.row.id)">
                                                    <el-button size="mini" type="danger" style="width: 72px;"
                                                        slot="reference">Cancel
                                                    </el-button>
                                                </el-popconfirm>
                                            </el-col>
                                        </el-row>
                                        <el-row v-if="scope.row.status == 1">
                                            <el-col :span="8">
                                                <el-popconfirm title="The inventory will be returned to JPC HQ Private Warehouse. Please arrange stock return to JPC HQ manually. Do you confirm?"
                                                    confirmButtonText="Yes" cancelButtonText="No"
                                                    @confirm="updateStatusEvent(3, scope.row.id)">
                                                    <el-button size="mini" type="warning" style="width: 72px;"
                                                        slot="reference">Expire
                                                    </el-button>
                                                </el-popconfirm>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </el-table-column>
                                <el-table-column width="120">
                                    <template slot-scope="scope">
                                        <div style="display: flex;justify-content: center;">
                                            <el-popconfirm v-if="scope.row.status == 1"
                                                title="Confirm to re-send Push Notification to Member?"
                                                confirmButtonText="Yes" cancelButtonText="No"
                                                @confirm="handlePush(scope.row.id)">
                                                <el-button size="mini" type="primary" slot="reference">Re-Push
                                                </el-button>
                                            </el-popconfirm>
                                        </div>
                                    </template>
                                </el-table-column>
                                
                                <el-table-column label="Action" width="120" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button size="mini" v-if="checkPermission('gift_Request_VIEW')"
                                            @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-col :span="24" class="el-table_footertoolbar">
                                <el-pagination layout="total, sizes, prev, pager, next, jumper"
                                    @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :total="total"
                                    style="float: right">
                                </el-pagination>
                            </el-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import config from "../config";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            page: 1, //当前页数
            pagesize: 10, //一页显示几条
            total: 0,
            rows: [],
            giftName: '',
            multipleSelection: [],
            sortType: "",
            sortName: "",
            memberNo: "",
            selectDate: [],
            selectStatus: "",
            searchGiftStoreName: '',
            giftStoreList: [],
            orderNo:''
        };
    },
    components: {
    },
    computed: {
        giftStoreMap() {
            return this.giftStoreList.map(i => {
                return {
                    value: i.id,
                    label: i.storeName
                }
            })
        },
        statusMap() {
            return {
                0: "Open",
                1: "Ready",
                2: "Cancelled",
                3: "Expired",
                4: 'InTransit',
                5: 'Complete'
            }
        },
        statusSelectMap() {
            return [
                {
                    label: "Open",
                    value: 0
                },
                {
                    label: "Ready",
                    value: 1
                },
                {
                    label: "Cancelled",
                    value: 2
                },
                {
                    label: "Expired",
                    value: 3
                },
                {
                    label: "InTransit",
                    value: 4
                }
            ]
        }
    },
    created() {
    },
    methods: {
        async init() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = this.page;
            objdata.pageSize = this.pagesize;
            objdata.giftName = this.giftName;
            objdata.memberNo = this.memberNo;
            objdata.sortName = this.sortName;
            objdata.sortType = this.sortType;
            objdata.beginDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[0]).format("YYYY-MM-DD") : '';
            objdata.endDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[1]).format("YYYY-MM-DD") : '';
            objdata.status = this.selectStatus
            objdata.orderNo = this.orderNo
            objdata.giftStoreId = this.searchGiftStoreName
            objdata.apiUrl = this.apiConfig.giftRequestList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.rows = data.data.result.giftRequestList;
            this.total = data.data.result.total;
        },
        async handleArrangeDelivery() {
            var that = this;
            if (this.multipleSelection.length != 0) {
                var firstItem = this.multipleSelection[0]
                const storeCenterDifferentList = this.multipleSelection.filter(i => {
                    return i.giftStoreId != firstItem.giftStoreId
                })
                const storeCenterIsNotOpenList = this.multipleSelection.filter(i => {
                    return i.status != 0
                })
                const storeCenterisHqList =  this.multipleSelection.filter(i => {
                    return i.isHq == 1
                })
                if(storeCenterisHqList.length){
                    this.$store.commit("setwarning", {
                        string: 'Operation fail. Selected orders contains HQ orders.',
                        boolean: true,
                        button: [{
                            name: "Cancel",
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false,
                                });
                            }
                        }]
                    })
                }
                else if (storeCenterDifferentList.length) {
                    this.$store.commit("setwarning", {
                        string: 'Operation failed. Selected orders must be deliver to the same Pickup Store.',
                        boolean: true,
                        button: [{
                            name: "Cancel",
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false,
                                });
                            }
                        }]
                    })
                } else if(storeCenterIsNotOpenList.length){
                    this.$store.commit("setwarning", {
                        string: 'Operation failed. All selected orders must be of Open status.',
                        boolean: true,
                        button: [{
                            name: "Cancel",
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false,
                                });
                            }
                        }]
                    })
                }else {
                    this.$store.commit("setwarning", {
                        string: `Do you confirm to group the selected orders and arrange delivery to ${firstItem.giftStoreName}`,
                        boolean: true,
                        button: [{
                            name: this.$i18n.t("message.Confirm"),
                            callBack: async function () {
                                that.$store.commit("setwarning", { string: "", boolean: false });
                                let ids = [];
                                let objdata = that.getAuthObj();
                                if (that.multipleSelection.length != 0) {
                                    for (let i = 0; i < that.multipleSelection.length; i++) {
                                        ids.push(that.multipleSelection[i].id);
                                    }
                                }
                                objdata.fromGiftStoreId = '';
                                objdata.endGiftStoreId = firstItem.giftStoreId;
                                objdata.address = '';
                                objdata.lstRequest = ids.join(",");

                                objdata.apiUrl = that.apiConfig.giftDeliveryCreate;
                                let data = await that.$store.dispatch("apiEvent", objdata);
                                if (data == "000104") {
                                    that.timeoutEvent();
                                    return;
                                }
                                if (!data) return;
                                if (data.data.status_code === "0") {
                                    that.multipleSelection = []
                                    that.init()
                                    that.$store.commit("setwarning", {
                                        string: "",
                                        boolean: false,
                                        button: [],
                                    });
                                }
                            }
                        }, {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () { that.$store.commit("setwarning", { string: "", boolean: false }); }
                        }]
                    });
                }


            }


        },
        handleSelectionChange(val) {
            this.multipleSelection = val.map((i) => {
                return {
                    ...i
                };
            });
        },
        async updateStatusEvent(status, id) {
            var objdata = this.getAuthObj();
            objdata.id = id
            objdata.status = status

            objdata.apiUrl = this.apiConfig.giftRequestUpdateStatus;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            await this.init()
        },
        async search() {
            this.page = 1
            this.init();
        },
        cancel: function () {
            this.$store.commit("setwarning", { string: "", boolean: false });
        },
        handleDbClick: function (row) {
            this.$router.push({
                path: "/main/giftRequestDetail",
                query: {
                    id: row.id,
                },
            });
        }, async getGitStore() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = 1;
            objdata.pageSize = 9999;

            objdata.apiUrl = this.apiConfig.giftStoreList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.giftStoreList = data.data.result.giftStoreList;
        },
        async handlePush(id) {
            var objdata = this.getAuthObj();

            objdata.id = id;

            objdata.apiUrl = this.apiConfig.giftRequestPush;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;

        }
    },
    mounted() {
        this.getGitStore()
        this.init();
    },
};
</script>
  